"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.smallop = void 0;
var FontData_js_1 = require("../../FontData.js");
var smallop_js_1 = require("../../../common/fonts/tex/smallop.js");
exports.smallop = (0, FontData_js_1.AddCSS)(smallop_js_1.smallop, {
    0x2044: { c: '/' },
    0x2329: { c: '\\27E8' },
    0x232A: { c: '\\27E9' },
    0x2758: { c: '\\2223' },
    0x2A0C: { c: '\\222C\\222C' },
    0x3008: { c: '\\27E8' },
    0x3009: { c: '\\27E9' },
});
//# sourceMappingURL=smallop.js.map